import { render, staticRenderFns } from "./PlanetToast.vue?vue&type=template&id=b457765a&scoped=true"
import script from "./PlanetToast.vue?vue&type=script&lang=js"
export * from "./PlanetToast.vue?vue&type=script&lang=js"
import style0 from "./PlanetToast.vue?vue&type=style&index=0&id=b457765a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b457765a",
  null
  
)

export default component.exports